import { FetchNotificationsPayload } from "PFCore/services/notifications/fetch_notifications";
import { FetchNotificationsGroupsPayload } from "PFCore/services/notifications/fetch_notifications_groups";

export const notificationsKeys = {
  all: () => ["notifications"],
  list: ({ excludedCategories, categories, ...otherParams }: FetchNotificationsPayload) => [
    ...notificationsKeys.all(),
    categories || [],
    excludedCategories || [],
    otherParams
  ],
  groups: (params?: FetchNotificationsGroupsPayload) => [
    ...notificationsKeys.all(),
    "groups",
    ...(params ? [params] : [])
  ],
  settings: () => [...notificationsKeys.all(), "profile_settings"]
};
